<template>
  <div>
    <div class="row" v-if="searchCriteria.length">
      <div class="col-md-12">
        <span class="filter-tag no-drag text-muted2" v-for="(item, key) in searchCriteria">
          Page {{ item.level + 1 }} is <b>{{ item.url }}</b>
        </span>
        <span 
          class="btn btn-light"
          @click="
          searchCriteria = []
          computePathway()
          ">Clear Condition</span>
      </div>
    </div>
    <div id="gd"></div>


    <div class="row mt-3">
      <div class="col-md-2 text-center small text-muted font-weight-bold">PAGE 1</div>
      <div class="col-md-2 text-center small text-muted font-weight-bold">PAGE 2</div>
      <div class="col-md-2 text-center small text-muted font-weight-bold">PAGE 3</div>
      <div class="col-md-2 text-center small text-muted font-weight-bold">PAGE 4</div>
      <div class="col-md-2 text-center small text-muted font-weight-bold">PAGE 5</div>
    </div>
    <div class="row">
      <div class="col-md-2" v-for="index in 5" :key="index">
        <div style="background-color:##e9ecef;border-radius: 8px;">
          <div v-for="(item, key) in pathways[index - 1]"
            v-if="item.name && key < 5"
            style="border: 1px solid #dfdfdf; border-radius: 8px;" 
            :style="'min-height: 80px; height:' + ((Math.round(item.total / sumLevel[0] * screenheight))) + 'px !important'"
            class="px-3 py-3 my-2 shadow bg-white pointer" 
            @click="
              searchCriteria.push({
                level: index - 1,
                url: item.name
              })
              computePathway()
            "
          >
            <p class="fs-12 mb-0 pb-0" :style="'font-weight: 500;'">
              <font-awesome-icon icon="file-o" class="text-first fa fa-xs mr-2" />{{shorten(getPath(item.name), 25)}}  
              <!-- {{item.total}} / {{ sumLevel[0] }} * {{ screenheight }} = {{ ((Math.round(item.total / sumLevel[0] * screenheight))) }} -->
              <span class="float-right">
                <font-awesome-icon icon="user" class="fa fa-xs text-muted2 mr-1 small" />{{item.total}}
                <!--{{ Math.round(item.total / sumLevel[index - 1] * 100) + '%' }}-->
              </span>
              <br>
              <span class="small badge badge-danger mt-1" v-if="item.dropped / item.total * 100">-{{ Math.round(item.dropped / item.total * 100) + '%' }}</span>
            </p>
            
            <!--<br>
            {{getDomain(item.name)}}-->

          </div>
        </div>
      </div>
    </div>      
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  components: {},
  data: function () {
    return {
      pathdata: null,
      pathways: [],
      sumLevel: [],
      screenheight: 0,
      searchCriteria: []
    }
  },
  watch: {
    '$store.getters.datepicker.dashboard': {
      handler: function (date) {
        this.startDate = date.startDate
        this.endDate = date.endDate
        this.initiate()
        console.log(123)
      },
      deep: true
    },
  },  
  filters: {},
  methods: {   
    getPath(x) {
      let arr = x.split('/')
      arr.shift()

      return '/' + arr.join('/')
    },
    getDomain(x) {
      return x.split('/')[0]
    },
    computePathway() {
      let data = this.pathdata
      let levelArr = {}

      let sankeyData = {}
      
      for (let level = 0; level < 5; level++) {
        this.sumLevel[level] = 0
        levelArr[level] = []

        for (let i in data) {
          let destinations = data[i].destination.split(',');

          for (let i = 0; i < destinations.length; i++) {
            if (i >= 3) break

            let d = destinations[i].replace(/^http(s)?\:\/\/(www.)?/g, '').replace(/^www\./, '')
            let d2 = destinations[i + 1] ? destinations[i + 1].replace(/^http(s)?\:\/\/(www.)?/g, '').replace(/^www\./, '') : 'dropoff'

            let levelName = `${i}-${d}|${i+1}-${d2}`

            if (!sankeyData[levelName]) sankeyData[levelName] = 0
            sankeyData[levelName]++
          }

          if (!destinations[level]) continue

          if (this.searchCriteria.length) {
            let skip = false

            for (let s in this.searchCriteria) {
              if (!destinations[this.searchCriteria[s].level] || (destinations[this.searchCriteria[s].level] && destinations[this.searchCriteria[s].level].replace(/^http(s)?\:\/\/(www.)?/g, '').replace(/^www\./, '') !== this.searchCriteria[s].url)) {
                skip = true
                break
              }
            }

            if (skip) continue
          }

          let currentDestination = destinations[level].replace(/^http(s)?\:\/\/(www.)?/g, '').replace(/^www\./, '')

          let obj = {
            name: currentDestination,
            total: 1,
            dropped: (!destinations[level + 1]) ? 1 : 0
          }

          let existing = levelArr[level].some(function(item) {
            return item.name === currentDestination;
          })

          if (existing) {
            let noNextLevel = false

            if (!destinations[level + 1]) noNextLevel = true

            for (var i = 0; i < levelArr[level].length; i++) {
              if (levelArr[level][i].name === currentDestination) {
                  levelArr[level][i].total++;                  
                  if (noNextLevel) levelArr[level][i].dropped++;
                  break                           // exit loop and function
              }
            }              
          } else levelArr[level].push(obj);
          
          this.sumLevel[level]++
        }

        if (levelArr[level]) levelArr[level].sort((a,b) => b.total - a.total); // b - a for reverse sort

      }

      let label = []
      let color = []
      let source = []
      let target = []
      let value = []
      let x = []
      let y = []

      for (let levelName in sankeyData) {
        let sourceLabel = levelName.split('|')[0]
        let targetLabel = levelName.split('|')[1]

        label.push(sourceLabel)
        color.push('blue')

        if (sourceLabel.startsWith('0')) x.push(0)
        else if (sourceLabel.startsWith('1')) x.push(0.3)
        else if (sourceLabel.startsWith('2')) x.push(0.6)
        else if (sourceLabel.startsWith('3')) x.push(0.9)
        else x.push(1)

        if (sourceLabel.includes('dropoff')) y.push(1)
        else if (sourceLabel.startsWith('0')) x.push(0.6)
        else if (sourceLabel.startsWith('1')) x.push(0.9)
        else if (sourceLabel.startsWith('2')) x.push(1)
        else if (sourceLabel.startsWith('3')) x.push(1)        


        label.push(targetLabel)
        if (targetLabel.includes('dropoff')) color.push('red')
        else color.push('blue')

        if (targetLabel.startsWith('0')) x.push(0)
        else if (targetLabel.startsWith('1')) x.push(0.3)
        else if (targetLabel.startsWith('2')) x.push(0.6)
        else if (targetLabel.startsWith('3')) x.push(0.9)
        else x.push(1)

        if (targetLabel.includes('dropoff')) y.push(0.5)
        else y.push(0.2)

        source.push(label.indexOf(sourceLabel))
        target.push(label.indexOf(targetLabel))
        value.push(sankeyData[levelName])
      }

      var san = {
        type: "sankey",
        // orientation: "h",
        arrangement: "snap",
        node: {
          pad: 10,
          x: x,
          y: y,
          // thickness: 30,
          // line: {
          //   color: "black",
          //   width: 0.5
          // },
          label: label,
          color: color
        },
        link: {
          source: source,
          target: target,
          value:  value
        }
      }

      var data2 = [san]

      var layout = {
        title: "Basic Sankey",
        font: {
          size: 10
        }
      }

      Plotly.react('gd', data2, layout)
      this.pathways = levelArr      
    },
    shorten(string, len) {
      if (!string) return string

      if (string.length > len) return string.substring(0, len) + '...'
      else return string
    },    
    initiate() {
      this.$http
      .post(process.env.API_ENDPOINT + '/funnel/aggregated/pageview', {
        startDate: this.$store.getters.datepicker.dashboard.startDate,
        endDate: this.$store.getters.datepicker.dashboard.endDate,
      })
      .then((response) => {
        this.pathdata = response.data
        this.computePathway()
      })
    },
  },
  mounted() {
    this.screenheight = document.body.clientHeight - 300
    this.initiate()    
  },
  beforeMount() {
  },
}
</script>
<style>
thead {
  text-align: left;
}

.link {
  font-weight: bold;
  color: #007bff;
  cursor: pointer;
}

.delete-button:hover {
  transform: scale(1.1);
}

.text-wrap {
  display: inline-block;
  text-overflow: ellipsis;
  height: 30px;
}

.pointer {
  cursor: pointer;
}

.card-noframe {
  border: none !important;
  box-shadow: none !important;
}

.ipinfo-tbody td {
  white-space: nowrap;
  overflow: hidden;
}

.delete-button {
  visibility: none;
  cursor: pointer;
}

.card-hover:hover .delete-button {
  visibility: visible;
}

.text-inactive {
  color: #00000040;
}

.dropbtn {
  font-size: 16px;
  border: none;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content-website {
  display: block;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content-website a {
  color: var(--color);
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content-website a:hover {
  background-color: #0068cf1e;
}

.modebar {
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/pages/BehaviorFlow.vue